const wrap = document.getElementById('switcher');
const trigger = wrap.querySelector('.trigger');

function moveTo(btn) {
    const x = btn.offsetLeft - wrap.firstElementChild.offsetLeft;
    const w = btn.offsetWidth;
    wrap.style.setProperty('--x', x + 'px');
    wrap.style.setProperty('--w', w + 'px');
}


function init() {
    const active = wrap.querySelector('.button.active') || wrap.querySelector('.button');
    moveTo(active);
}

wrap.addEventListener('click', e => {
    const btn = e.target.closest('.button');
    if (!btn) return;
    wrap.querySelectorAll('.button').forEach(b => b.classList.toggle('active', b === btn));
    moveTo(btn);
});

window.addEventListener('load', init);
window.addEventListener('resize', () => {
    const active = wrap.querySelector('.button.active');
    if (active) moveTo(active);
});


(function ($) {

    $('.switcher button').click(function(){
        $('.switcher button').removeClass('active')
        $(this).addClass('active');
        if ($(this).is($(".switcher .button:last"))) {
            $('.design-slider-in').addClass('-hide');
            $('.design-slider-out').removeClass('-hide');
        } else {
            $('.design-slider-in').removeClass('-hide');
            $('.design-slider-out').addClass('-hide');
        }
    })

    function checkSliderImages(){
        var $slider = $('.design-slider');
        $('.design-slider .swiper-slide').each(function(){
            if (!$(this).find('.design-slider-first').length){
                $(this).addClass('no-first');
            }
            if (!$(this).find('.design-slider-second').length){
                $(this).addClass('no-second');
            }
        });
    }
    $(document).gp_ready(function(){
        checkSliderImages();
    });


})(jQuery);
